
<app-header></app-header>
<p>Thank you for your order from the 2020 National Specialty Online Store.</p>
<p>List of items shipped in this order:</p>
<router-outlet></router-outlet>

